import type {TFunction} from 'next-i18next';

export type Country = {
	countryCode: string;
	label: string;
};

export const COUNTRY_LIST: Country[] = [
	{
		countryCode: 'AD',
		label: 'Andorra',
	},
	{
		countryCode: 'AE',
		label: 'United Arab Emirates',
	},
	{
		countryCode: 'AF',
		label: 'Afghanistan',
	},
	{
		countryCode: 'AG',
		label: 'Antigua and Barbuda',
	},
	{
		countryCode: 'AI',
		label: 'Anguilla',
	},
	{
		countryCode: 'AL',
		label: 'Albania',
	},
	{
		countryCode: 'AM',
		label: 'Armenia',
	},
	{
		countryCode: 'AO',
		label: 'Angola',
	},
	{
		countryCode: 'AQ',
		label: 'Antarctica',
	},
	{
		countryCode: 'AR',
		label: 'Argentina',
	},
	{
		countryCode: 'AS',
		label: 'American Samoa',
	},
	{
		countryCode: 'AT',
		label: 'Austria',
	},
	{
		countryCode: 'AU',
		label: 'Australia',
	},
	{
		countryCode: 'AW',
		label: 'Aruba',
	},
	{
		countryCode: 'AX',
		label: 'Aland Islands',
	},
	{
		countryCode: 'AZ',
		label: 'Azerbaijan',
	},
	{
		countryCode: 'BA',
		label: 'Bosnia and Herzegovina',
	},
	{
		countryCode: 'BB',
		label: 'Barbados',
	},
	{
		countryCode: 'BD',
		label: 'Bangladesh',
	},
	{
		countryCode: 'BE',
		label: 'Belgium',
	},
	{
		countryCode: 'BF',
		label: 'Burkina Faso',
	},
	{
		countryCode: 'BG',
		label: 'Bulgaria',
	},
	{
		countryCode: 'BH',
		label: 'Bahrain',
	},
	{
		countryCode: 'BI',
		label: 'Burundi',
	},
	{
		countryCode: 'BJ',
		label: 'Benin',
	},
	{
		countryCode: 'BL',
		label: 'Saint Barthelemy',
	},
	{
		countryCode: 'BM',
		label: 'Bermuda',
	},
	{
		countryCode: 'BN',
		label: 'Brunei',
	},
	{
		countryCode: 'BO',
		label: 'Bolivia',
	},
	{
		countryCode: 'BQ',
		label: 'Bonaire, Sint Eustatius and Saba',
	},
	{
		countryCode: 'BR',
		label: 'Brazil',
	},
	{
		countryCode: 'BS',
		label: 'Bahamas',
	},
	{
		countryCode: 'BT',
		label: 'Bhutan',
	},
	{
		countryCode: 'BV',
		label: 'Bouvet Island',
	},
	{
		countryCode: 'BW',
		label: 'Botswana',
	},
	{
		countryCode: 'BY',
		label: 'Belarus',
	},
	{
		countryCode: 'BZ',
		label: 'Belize',
	},
	{
		countryCode: 'CA',
		label: 'Canada',
	},
	{
		countryCode: 'CC',
		label: 'Cocos Islands',
	},
	{
		countryCode: 'CD',
		label: 'Democratic Republic of the Congo',
	},
	{
		countryCode: 'CF',
		label: 'Central African Republic',
	},
	{
		countryCode: 'CG',
		label: 'Republic of the Congo',
	},
	{
		countryCode: 'CH',
		label: 'Switzerland',
	},
	{
		countryCode: 'CI',
		label: 'The Ivory Coast',
	},
	{
		countryCode: 'CK',
		label: 'Cook Islands',
	},
	{
		countryCode: 'CL',
		label: 'Chile',
	},
	{
		countryCode: 'CM',
		label: 'Cameroon',
	},
	{
		countryCode: 'CN',
		label: 'China',
	},
	{
		countryCode: 'CO',
		label: 'Colombia',
	},
	{
		countryCode: 'CR',
		label: 'Costa Rica',
	},
	{
		countryCode: 'CU',
		label: 'Cuba',
	},
	{
		countryCode: 'CV',
		label: 'Cape Verde',
	},
	{
		countryCode: 'CW',
		label: 'Curaçao',
	},
	{
		countryCode: 'CX',
		label: 'Christmas Island',
	},
	{
		countryCode: 'CY',
		label: 'Cyprus',
	},
	{
		countryCode: 'CZ',
		label: 'Czech Republic',
	},
	{
		countryCode: 'DE',
		label: 'Germany',
	},
	{
		countryCode: 'DJ',
		label: 'Djibouti',
	},
	{
		countryCode: 'DK',
		label: 'Denmark',
	},
	{
		countryCode: 'DM',
		label: 'Dominica',
	},
	{
		countryCode: 'DO',
		label: 'Dominican Republic',
	},
	{
		countryCode: 'DZ',
		label: 'Algeria',
	},
	{
		countryCode: 'EC',
		label: 'Ecuador',
	},
	{
		countryCode: 'EE',
		label: 'Estonia',
	},
	{
		countryCode: 'EG',
		label: 'Egypt',
	},
	{
		countryCode: 'EH',
		label: 'Western Sahara',
	},
	{
		countryCode: 'ER',
		label: 'Eritrea',
	},
	{
		countryCode: 'ES',
		label: 'Spain',
	},
	{
		countryCode: 'ET',
		label: 'Ethiopia',
	},
	{
		countryCode: 'FI',
		label: 'Finland',
	},
	{
		countryCode: 'FJ',
		label: 'Fiji',
	},
	{
		countryCode: 'FK',
		label: 'The Falkland Islands',
	},
	{
		countryCode: 'FM',
		label: 'Federated States of Micronesia',
	},
	{
		countryCode: 'FO',
		label: 'The Faroe Islands',
	},
	{
		countryCode: 'FR',
		label: 'France',
	},
	{
		countryCode: 'GA',
		label: 'Gabon',
	},
	{
		countryCode: 'GB',
		label: 'United Kingdom',
	},
	{
		countryCode: 'GD',
		label: 'Grenada',
	},
	{
		countryCode: 'GE',
		label: 'Georgia',
	},
	{
		countryCode: 'GF',
		label: 'French Guiana',
	},
	{
		countryCode: 'GG',
		label: 'Guernsey',
	},
	{
		countryCode: 'GH',
		label: 'Ghana',
	},
	{
		countryCode: 'GI',
		label: 'Gibraltar',
	},
	{
		countryCode: 'GL',
		label: 'Greenland',
	},
	{
		countryCode: 'GM',
		label: 'Gambia',
	},
	{
		countryCode: 'GN',
		label: 'Guinea',
	},
	{
		countryCode: 'GP',
		label: 'Guadeloupe',
	},
	{
		countryCode: 'GQ',
		label: 'Equatorial Guinea',
	},
	{
		countryCode: 'GR',
		label: 'Greece',
	},
	{
		countryCode: 'GS',
		label: 'South Georgia and the South Sandwich Islands',
	},
	{
		countryCode: 'GT',
		label: 'Guatemala',
	},
	{
		countryCode: 'GU',
		label: 'Guam',
	},
	{
		countryCode: 'GW',
		label: 'Guinea-Bissau',
	},
	{
		countryCode: 'GY',
		label: 'Guyana',
	},
	{
		countryCode: 'HK',
		label: 'Hong Kong',
	},
	{
		countryCode: 'HM',
		label: 'Heard and McDonald Islands',
	},
	{
		countryCode: 'HN',
		label: 'Honduras',
	},
	{
		countryCode: 'HR',
		label: 'Croatia',
	},
	{
		countryCode: 'HT',
		label: 'Haiti',
	},
	{
		countryCode: 'HU',
		label: 'Hungary',
	},
	{
		countryCode: 'ID',
		label: 'Indonesia',
	},
	{
		countryCode: 'IE',
		label: 'Ireland',
	},
	{
		countryCode: 'IL',
		label: 'Israel',
	},
	{
		countryCode: 'IM',
		label: 'Isle of Man',
	},
	{
		countryCode: 'IN',
		label: 'India',
	},
	{
		countryCode: 'IO',
		label: 'British Indian Ocean Territory',
	},
	{
		countryCode: 'IQ',
		label: 'Iraq',
	},
	{
		countryCode: 'IR',
		label: 'Iran',
	},
	{
		countryCode: 'IS',
		label: 'Iceland',
	},
	{
		countryCode: 'IT',
		label: 'Italy',
	},
	{
		countryCode: 'JE',
		label: 'Jersey',
	},
	{
		countryCode: 'JM',
		label: 'Jamaica',
	},
	{
		countryCode: 'JO',
		label: 'Jordan',
	},
	{
		countryCode: 'JP',
		label: 'Japan',
	},
	{
		countryCode: 'KE',
		label: 'Kenya',
	},
	{
		countryCode: 'KG',
		label: 'Kyrgyzstan',
	},
	{
		countryCode: 'KH',
		label: 'Cambodia',
	},
	{
		countryCode: 'KI',
		label: 'Kiribati',
	},
	{
		countryCode: 'KM',
		label: 'The Comoros',
	},
	{
		countryCode: 'KN',
		label: 'Saint Kitts and Nevis',
	},
	{
		countryCode: 'KP',
		label: 'North Korea',
	},
	{
		countryCode: 'KR',
		label: 'South Korea',
	},
	{
		countryCode: 'KW',
		label: 'Kuwait',
	},
	{
		countryCode: 'KY',
		label: 'Cayman Islands',
	},
	{
		countryCode: 'KZ',
		label: 'Kazakhstan',
	},
	{
		countryCode: 'LA',
		label: 'Laos',
	},
	{
		countryCode: 'LB',
		label: 'Lebanon',
	},
	{
		countryCode: 'LC',
		label: 'Saint Lucia',
	},
	{
		countryCode: 'LI',
		label: 'Liechtenstein',
	},
	{
		countryCode: 'LK',
		label: 'Sri Lanka',
	},
	{
		countryCode: 'LR',
		label: 'Liberia',
	},
	{
		countryCode: 'LS',
		label: 'Lesotho',
	},
	{
		countryCode: 'LT',
		label: 'Lithuania',
	},
	{
		countryCode: 'LU',
		label: 'Luxembourg',
	},
	{
		countryCode: 'LV',
		label: 'Latvia',
	},
	{
		countryCode: 'LY',
		label: 'Libya',
	},
	{
		countryCode: 'MA',
		label: 'Morocco',
	},
	{
		countryCode: 'MC',
		label: 'Monaco',
	},
	{
		countryCode: 'MD',
		label: 'Moldova',
	},
	{
		countryCode: 'ME',
		label: 'Montenegro',
	},
	{
		countryCode: 'MF',
		label: 'Saint Martin (French Antilles)',
	},
	{
		countryCode: 'MG',
		label: 'Madagascar',
	},
	{
		countryCode: 'MH',
		label: 'Marshall Islands',
	},
	{
		countryCode: 'MK',
		label: 'Macedonia ',
	},
	{
		countryCode: 'ML',
		label: 'Mali',
	},
	{
		countryCode: 'MM',
		label: 'Burma',
	},
	{
		countryCode: 'MN',
		label: 'Mongolia',
	},
	{
		countryCode: 'MO',
		label: 'Macao',
	},
	{
		countryCode: 'MP',
		label: 'Northern Mariana Islands',
	},
	{
		countryCode: 'MQ',
		label: 'Martinique',
	},
	{
		countryCode: 'MR',
		label: 'Mauritania',
	},
	{
		countryCode: 'MS',
		label: 'Montserrat',
	},
	{
		countryCode: 'MT',
		label: 'Malta',
	},
	{
		countryCode: 'MU',
		label: 'Mauritius',
	},
	{
		countryCode: 'MV',
		label: 'The Maldives',
	},
	{
		countryCode: 'MW',
		label: 'Malawi',
	},
	{
		countryCode: 'MX',
		label: 'Mexico',
	},
	{
		countryCode: 'MY',
		label: 'Malaysia',
	},
	{
		countryCode: 'MZ',
		label: 'Mozambique',
	},
	{
		countryCode: 'NA',
		label: 'Namibia',
	},
	{
		countryCode: 'NC',
		label: 'New Caledonia',
	},
	{
		countryCode: 'NE',
		label: 'Niger',
	},
	{
		countryCode: 'NF',
		label: 'Norfolk Island',
	},
	{
		countryCode: 'NG',
		label: 'Nigeria',
	},
	{
		countryCode: 'NI',
		label: 'Nicaragua',
	},
	{
		countryCode: 'NL',
		label: 'The Netherlands',
	},
	{
		countryCode: 'NO',
		label: 'Norway',
	},
	{
		countryCode: 'NP',
		label: 'Nepal',
	},
	{
		countryCode: 'NR',
		label: 'Nauru',
	},
	{
		countryCode: 'NU',
		label: 'Niue',
	},
	{
		countryCode: 'NZ',
		label: 'New Zealand',
	},
	{
		countryCode: 'OM',
		label: 'Oman',
	},
	{
		countryCode: 'PA',
		label: 'Panama',
	},
	{
		countryCode: 'PE',
		label: 'Peru',
	},
	{
		countryCode: 'PF',
		label: 'French Polynesia',
	},
	{
		countryCode: 'PG',
		label: 'Papua New Guinea',
	},
	{
		countryCode: 'PH',
		label: 'The Philippines',
	},
	{
		countryCode: 'PK',
		label: 'Pakistan',
	},
	{
		countryCode: 'PL',
		label: 'Poland',
	},
	{
		countryCode: 'PM',
		label: 'Saint Pierre and Miquelon',
	},
	{
		countryCode: 'PN',
		label: 'The Pitcairn Islands',
	},
	{
		countryCode: 'PR',
		label: 'Puerto Rico',
	},
	{
		countryCode: 'PS',
		label: 'Palestine',
	},
	{
		countryCode: 'PT',
		label: 'Portugal',
	},
	{
		countryCode: 'PW',
		label: 'Palau',
	},
	{
		countryCode: 'PY',
		label: 'Paraguay',
	},
	{
		countryCode: 'QA',
		label: 'Qatar',
	},
	{
		countryCode: 'RE',
		label: 'Reunion',
	},
	{
		countryCode: 'RO',
		label: 'Romania',
	},
	{
		countryCode: 'RS',
		label: 'Serbia',
	},
	{
		countryCode: 'RU',
		label: 'Russia',
	},
	{
		countryCode: 'RW',
		label: 'Rwanda',
	},
	{
		countryCode: 'SA',
		label: 'Saudi Arabia',
	},
	{
		countryCode: 'SB',
		label: 'The Solomon Islands',
	},
	{
		countryCode: 'SC',
		label: 'Seychelles',
	},
	{
		countryCode: 'SD',
		label: 'Sudan',
	},
	{
		countryCode: 'SE',
		label: 'Sweden',
	},
	{
		countryCode: 'SG',
		label: 'Singapour',
	},
	{
		countryCode: 'SH',
		label: 'Saint Helena, Ascension and Tristan da Cunha',
	},
	{
		countryCode: 'SI',
		label: 'Slovenia',
	},
	{
		countryCode: 'SJ',
		label: 'Svalbard and Jan Mayen',
	},
	{
		countryCode: 'SK',
		label: 'Slovakia',
	},
	{
		countryCode: 'SL',
		label: 'Sierra Leone',
	},
	{
		countryCode: 'SM',
		label: 'San Marino',
	},
	{
		countryCode: 'SN',
		label: 'Senegal',
	},
	{
		countryCode: 'SO',
		label: 'Somalia',
	},
	{
		countryCode: 'SR',
		label: 'Suriname',
	},
	{
		countryCode: 'SS',
		label: 'South Sudan',
	},
	{
		countryCode: 'ST',
		label: 'Sao Tomé-et-Principe',
	},
	{
		countryCode: 'SV',
		label: 'El Salvador',
	},
	{
		countryCode: 'SX',
		label: 'Saint Martin',
	},
	{
		countryCode: 'SY',
		label: 'Syria',
	},
	{
		countryCode: 'SZ',
		label: 'Swaziland',
	},
	{
		countryCode: 'TC',
		label: 'Turks and Caicos Islands',
	},
	{
		countryCode: 'TD',
		label: 'Chad',
	},
	{
		countryCode: 'TF',
		label: 'French Southern and Antarctic Territories',
	},
	{
		countryCode: 'TG',
		label: 'Togo',
	},
	{
		countryCode: 'TH',
		label: 'Thailand',
	},
	{
		countryCode: 'TJ',
		label: 'Tajikistan',
	},
	{
		countryCode: 'TK',
		label: 'Tokelau',
	},
	{
		countryCode: 'TL',
		label: 'East Timor',
	},
	{
		countryCode: 'TM',
		label: 'Turkmenistan',
	},
	{
		countryCode: 'TN',
		label: 'Tunisia',
	},
	{
		countryCode: 'TO',
		label: 'Tonga',
	},
	{
		countryCode: 'TR',
		label: 'Turkey',
	},
	{
		countryCode: 'TT',
		label: 'Trinidad and Tobago',
	},
	{
		countryCode: 'TV',
		label: 'Tuvalu',
	},
	{
		countryCode: 'TW',
		label: 'Taiwan',
	},
	{
		countryCode: 'TZ',
		label: 'Tanzania',
	},
	{
		countryCode: 'UA',
		label: 'Ukraine',
	},
	{
		countryCode: 'UG',
		label: 'Uganda',
	},
	{
		countryCode: 'UM',
		label: 'United States minor outlying islands',
	},
	{
		countryCode: 'US',
		label: 'United States of America',
	},
	{
		countryCode: 'UY',
		label: 'Uruguay',
	},
	{
		countryCode: 'UZ',
		label: 'Uzbekistan',
	},
	{
		countryCode: 'VA',
		label: 'Holy See (Vatican City)',
	},
	{
		countryCode: 'VC',
		label: 'Saint Vincent and the Grenadines',
	},
	{
		countryCode: 'VE',
		label: 'Venezuela',
	},
	{
		countryCode: 'VG',
		label: 'British Virgin Islands',
	},
	{
		countryCode: 'VI',
		label: 'U.S. Virgin Islands',
	},
	{
		countryCode: 'VN',
		label: 'Vietnam',
	},
	{
		countryCode: 'VU',
		label: 'Vanuatu',
	},
	{
		countryCode: 'WF',
		label: 'Wallis and Futuna',
	},
	{
		countryCode: 'WS',
		label: 'Samoa',
	},
	{
		countryCode: 'YE',
		label: 'Yemen',
	},
	{
		countryCode: 'YT',
		label: 'Mayotte',
	},
	{
		countryCode: 'ZA',
		label: 'South Africa',
	},
	{
		countryCode: 'ZM',
		label: 'Zambia',
	},
	{
		countryCode: 'ZW',
		label: 'Zimbabwe',
	},
];

export const EVERYWHERE_COUNTRY_CODE = 'WW';

export const COUNTRY_MAP = COUNTRY_LIST.reduce<{[key: string]: Country}>(
	(acc, c) => {
		acc[c.countryCode] = c;
		return acc;
	},
	{},
);

export const getCountryCodes = () => COUNTRY_LIST.map(c => c.countryCode);

export const getEverywhereCountry = (t: TFunction) => ({
	countryCode: EVERYWHERE_COUNTRY_CODE,
	label: t('analyticslabel_text_worldwide_d4c-web'),
});

export const getCountryList = (
	t: TFunction,
	formatCountry: (
		code: string,
		options?: Intl.DisplayNamesOptions,
	) => string | undefined,
): Country[] => {
	return COUNTRY_LIST.map(c => {
		const label = formatCountry(c.countryCode.toUpperCase()) || c.label;
		return {
			countryCode: c.countryCode,
			label: c.countryCode !== label ? label : c.label,
		};
	});
};

export const getCountryListWithEverywhere = (
	t: TFunction,
	formatCountry: (
		code: string,
		options?: Intl.DisplayNamesOptions,
	) => string | undefined,
): Country[] => {
	return [getEverywhereCountry(t), ...getCountryList(t, formatCountry)];
};
